import React, {Component} from 'react';
import Screen from './scenes/Screen'
import {QueryRenderer, graphql} from 'react-relay'
import environment from './Environment'
import SetupView from './components/SetupView';
import './scss/App.scss';

const AppQuery = graphql`
    query AppQuery($index: Int) {
        screen(index: $index) {
            ...Screen_screen
        }
        screenConfig: infoMonitorConfig {
            ...Screen_config
        }
    }
`;

class App extends Component {
	render() {
		return (<QueryRenderer environment={environment} query={AppQuery} variables={{
			index: 1
		}} render={({error, props}) => {
			if (error) {
				return <SetupView error={error.message}/>
			} else if (props) {
				return (
					<Screen screen={props.screen} config={props.screenConfig}/>
				)
			}
			return <div className="Loader">Loading</div>
		}}/>)
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js